import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"

import {
  Container,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Alert,
  Card,
  CardBody,
  CardTitle
} from "shards-react"

import { Table } from "react-bootstrap"

import { isMobile } from "react-device-detect"

import CapeMenuTray from "../cape/capeMenuTray"

import ProgramSummary from "../components/programSummary"
import Switcher from "../components/switcher"

// View Components
import MobileView from "../common/mobileView"
import BrowserView from "../common/browserView"

// Video Resources
import StudentVideo from "../videos/csec.mp4"

// Internal JavaSript libraries
import { getCountry } from "../js/getCountry"

class CSEC extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      // Import the routes for the country
      routes: require("../data/routes.json"),
      country: getCountry(this.props.pageContext.countryCode)
    }

    this.routify = this.routify.bind(this)
  }

  routify(route) {
    return "/" + this.state.country.slug + route
  }

  render() {
    const Subjects = () => (
      <>
        <h5 className="pb-4">Subjects Offered</h5>
        <Table light hover responsive style={{ width: "100%" }}>
          <thead>
            <tr></tr>
          </thead>
          <tbody>
            <tr>
              <td>Accounting</td>
              <td>Biology</td>
            </tr>
            <tr>
              <td>Caribbean Studies</td>
              <td>Chemistry</td>
            </tr>
            <tr>
              <td>Communication Studies</td>
              <td>Computer Science</td>
            </tr>
            <tr>
              <td>Economics</td>
              <td>Entrepreneurship</td>
            </tr>
            <tr>
              <td>Geography</td>
              <td>Information Technology</td>
            </tr>
            <tr>
              <td>Law</td>
              <td>Management of Business</td>
            </tr>
            <tr>
              <td>Pure Mathematics</td>
              <td>Sociology</td>
            </tr>
          </tbody>
        </Table>
      </>
    )

    const Video = () => (
      <video
        style={{ width: "100%" }}
        preload="auto"
        autoPlay={true}
        loop
        muted
      >
        <source src={StudentVideo} type="video/mp4" />
      </video>
    )

    const NoticeItem = props => (
      <>
        <br />
        <Card style={{ listStyleType: "none" }}>
          <CardBody>
            <CardTitle>{props.title}</CardTitle>
            <div dangerouslySetInnerHTML={{ __html: props.description }} />
          </CardBody>
        </Card>
      </>
    )

    const Notices = () => (
      <div>
        <h5>Live Updates</h5>

        {this.props.pageContext.notices ? (
          this.props.pageContext.notices.map(notice => (
            <NoticeItem
              key={notice.id}
              title={notice.title}
              description={notice.description}
            />
          ))
        ) : (
          <p>No updates available</p>
        )}
      </div>
    )

    const ApplyButton = () => (
      <>
        <></>
      </>
    )

    return (
      <Layout countryCode={this.props.pageContext.countryCode}>
        <Seo
          countryCode={this.props.pageContext.countryCode}
          title={this.props.pageContext.name}
        />

        <MobileView>
          <Video />
        </MobileView>

        <Container>
          <Row>
            <Col md={7}>
              <Breadcrumb>
                <BreadcrumbItem>
                  <a href={this.routify(this.state.routes.home)}>Home</a>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <a href={this.routify(this.state.routes.programmes)}>
                    Programmes
                  </a>
                </BreadcrumbItem>
                <BreadcrumbItem active>CAPE</BreadcrumbItem>
              </Breadcrumb>
              <h3 className="">{this.props.pageContext.name}</h3>
              <CapeMenuTray
                slug={this.state.country.slug}
                countryCode={this.props.pageContext.countryCode}
              />
              <p>
                {this.props.pageContext.description} Classes begin{" "}
                {this.props.pageContext.startDate}. Enrolled students get access
                to:
              </p>

              <ul className="ul pt-3">
                <li>2-3 hours of class time weekly for each subject</li>
                <li style={{ paddingTop: "15px" }}>Weekly assignments</li>
                <li style={{ paddingTop: "15px" }}>Monthly mock exams</li>
                <li style={{ paddingTop: "15px" }}>
                  Monthly progress reports for parents
                </li>
                <li style={{ paddingTop: "15px" }}>Virtual textbooks</li>
                <li style={{ paddingTop: "15px" }}>
                  Additional virtual class materials
                </li>
              </ul>

              <br />
              <Switcher body countryCode={this.props.pageContext.countryCode} />

              <MobileView>
                <br />
                <Subjects />
                <br />
              </MobileView>

              <Alert
                theme={isMobile ? "primary" : "primary"}
                className={isMobile ? "break-container" : ""}
              >
                <br />
                <h5 className="text-light">Tuition & Fees</h5>

                <p>{this.props.pageContext.cost}</p>
                <p>{this.props.pageContext.costDescription}</p>

                <i class="fa-solid fa-circle-info pr-2"></i>
                {this.props.pageContext.promotion}
                <br />
                <br />
              </Alert>
              <br />
              <ProgramSummary pageContext={this.props.pageContext} />
            </Col>
            <Col md={5}>
              <BrowserView>
                <br />
                <br />
                <Video />

                <br />
                <br />
                <Subjects />

                <br />
              </BrowserView>

              <Notices />
            </Col>
          </Row>
        </Container>
      </Layout>
    )
  }
}

export default CSEC
